import React from 'react';
import { OccurrenceSummary } from '../../types/analytics';

interface OccurrenceFilterDropdownProps {
  occurrences: OccurrenceSummary[];
  selectedOccurrenceId: string | undefined;
  onChange: (occurrenceId: string | undefined) => void;
}

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
});

const OccurrenceFilterDropdown: React.FC<OccurrenceFilterDropdownProps> = ({
  occurrences,
  selectedOccurrenceId,
  onChange,
}) => {
  return (
    <select
      value={selectedOccurrenceId ?? ''}
      onChange={(event) => onChange(event.target.value || undefined)}
      className="bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm text-gray-900 dark:text-white"
    >
      <option value="">All Occurrences</option>
      {occurrences.map((occurrence) => (
        <option key={occurrence.occurrenceId} value={occurrence.occurrenceId}>
          {`Occ #${occurrence.occurrenceNumber} — ${dateFormatter.format(new Date(occurrence.startsAt))}`}
        </option>
      ))}
    </select>
  );
};

export default OccurrenceFilterDropdown;
